/**
 * Route de contact localisée pour le CTA « Contribuer à ce projet » de la
 * fiche projet publique (`ProjectDetail.tsx`).
 *
 * Fonction pure, sans dépendance lourde : contrairement à `fiche-projet.ts`
 * (SERVEUR UNIQUEMENT — il importe les gros catalogues JSON), ce module peut
 * être importé tel quel dans un composant navigateur sans alourdir le paquet,
 * et testé directement hors React.
 *
 * Correctif visibilité CTA (audit UI, 25/09/2026) : le bouton ajouté en tête
 * de colonne latérale et celui de la barre d'action mobile pointent vers
 * exactement la même route que le CTA historique de la fiche — cette
 * fonction ne fait qu'isoler ce calcul pour pouvoir le figer par un test.
 */
export type LocaleContact = 'fr' | 'en'

export function contactCtaHref(locale: LocaleContact): string {
  return locale === 'en' ? '/en/contact' : '/contact'
}
